import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a737ca2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button" }
const _hoisted_2 = {
  key: 0,
  class: "count"
}
const _hoisted_3 = { class: "button-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button-arrow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.buttonItem.count)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.buttonItem.count), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_router_link, {
      to: _ctx.buttonItem.path,
      class: "button-inner"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.buttonItem.label), 1),
        _hoisted_4
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}